import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const SQRT = () => {
  return (
    <CardSection id="SQRT" title="SQRT">
      <Paragraph>
        양의 제곱근을 반환합니다. 이 함수는 Excel의 SQRT 함수와 동일한 출력을
        제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>SQRT(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 제곱근을 계산할 양의 숫자입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>SQRT(`Column`)</Paragraph>
        <Img src="computeSqrt" />
      </ListSection>
    </CardSection>
  );
};
